import React from 'react';
import {AuraCard} from './applicant-profile/aura-card.component';
import {Recommendation, RecommendationCard} from './applicant-profile/recommendation-card.component';
import {RelevantWork} from './applicant-profile/relevant-work.component';
import {Account, Cred} from '../../../models';
import moment from 'moment';
import {PerforationDivider} from '../../../components/perforation-divider';
import ElevatorPitch from './elevator-pitch.component';
import ExperienceEducation from './applicant-profile/experience-education-details.component';

interface ApplicantProfileCardProps {
  auraScore: number;
  recommendation?: Recommendation;
  account: Account;
  cred: Cred;
}

export const ApplicantProfileCard: React.FC<ApplicantProfileCardProps> = ({auraScore, recommendation, account, cred}) => {
  return (
    <div className="relative w-full bg-gray-100 rounded-2xl p-6 sm:px-8 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1.5fr_auto_1fr] gap-8 relative z-10 items-start">
        <div className="lg:col-start-1 lg:col-end-2 max-h-[calc(100vh-220px)] overflow-y-auto">
          <RelevantWork accountId={account.id} />
        </div>

        <div className="hidden lg:block lg:col-start-2 lg:col-end-3 h-full">
          <PerforationDivider className="h-full" />
        </div>

        <div className="flex flex-col gap-6 max-h-[calc(100vh-220px)] overflow-y-auto">
          <ElevatorPitch account={account} />
          <ExperienceEducation account={account} />
        </div>
        <div className="hidden lg:block lg:col-start-4 lg:col-end-5 h-full">
          <PerforationDivider className="h-full" dense />
        </div>

        <div className="lg:col-start-5 lg:col-end-6 flex flex-col gap-6 max-h-[calc(100vh-220px)] overflow-y-auto">
          <AuraCard score={auraScore} updatedAt={moment().format('YYYY-MM-DD')} userSkills={cred.skills || []} />
          {recommendation && <RecommendationCard recommendation={recommendation} />}
        </div>
      </div>
    </div>
  );
};
